import React, { useEffect, useState } from "react";
import * as api from "../../api/getapi";
import useApi from "../../Hooks/useApi";
import { Col, Row } from "react-bootstrap";
import PaginationBar from "../../Components/PaginationBar";
import CustomizeTableview from "../../Components/TableViews/CustomizeTableview";
import NoResult from "../../Components/NoResult";
import customloader from "../../assets/images/RollingLoader.gif";

const SMS = ({ sizeOfPages, searchInput, fromDate, toDate, currentTab }) => {
  const fetchAllSMSNotifications = useApi(api.fetchAllSMSNotifications);
  const [noOfPages, setNoOfPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState(0);
  const [orderBy, setOrderBy] = useState({ created_at: "DESC" });
  const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [refresh, toggle] = useState(false);
  const fetchAllSMS = async () => {
    const res = await fetchAllSMSNotifications.request({
      size: sizeOfPages,
      page: currentPage,
      search: searchInput,
      order: orderBy,
      date: { from: fromDate, to: toDate },
    });
    const data = res?.data;
    setIsLoading(false);
    if (data) {
      setNotifications(data?.data);
      setCount(data?.pagination?.total);
      if (data?.pagination?.totalPages === 0) {
        setNoOfPages(0);
      } else {
        setNoOfPages(data?.pagination?.totalPages);
        if (currentPage > data?.pagination?.totalPages) {
          setCurrentPage(data?.pagination?.totalPages);
        }
      }
    } else {
      setNotifications([]);
    }
  };
  useEffect(() => {
    if (currentTab === "SMS") {
      fetchAllSMS();
    }
  }, [currentPage, sizeOfPages, searchInput, fromDate, toDate, currentTab]);
  useEffect(() => {
    if (currentPage === 1) {
      toggle((prev) => !prev);
    } else {
      changePage(1);
    }
  }, []);
  const changePage = (page) => {
    setCurrentPage(page);
  };
  return (
    <>
      {isLoading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "70vh" }}>
          <img src={customloader} alt="customloader" width="100" height="100" />
        </div>
      ) : !notifications[0] ? (
        <NoResult name="Notifications" />
      ) : (
        <>
          <CustomizeTableview data={notifications} columnNotShow={["id", "user_id", "message_ref", "status_code"]} dateColumn={["created_at"]} sortColumn={["created_at"]} orderBy={orderBy} setOrderBy={setOrderBy} collapsableColumns={["message"]} actions={false} />
          <Row className="mt-5">
            <Col className="d-none d-lg-block" md="6" lg="3">
              <span className="text-secondary fs-6">{count} Result(s)</span>
            </Col>
            <Col xs="12" lg="6">
              <PaginationBar noOfPages={noOfPages} currentPage={currentPage} changePage={changePage} />
            </Col>
            <Col className="d-md-none d-flex align-items-center mt-3" xs="6" lg="3">
              <span className="text-secondary fs-6">{count} Result(s)</span>
            </Col>
            <Col xs="6" lg="3" className="text-end mt-3"></Col>
          </Row>
        </>
      )}
    </>
  );
};

export default SMS;
